import { Config } from '../_config'
import { Environment } from '../_kernel/Environment'
import { Cookie } from './Cookie'

export class FactoryCookie {
  static create({ config }: { config: Config }) {
    return new FactoryCookie(config)
  }

  constructor(private config: Config) {}

  async cookie(): Promise<Cookie> {
    const isNode = Environment.create().isNode()

    return isNode
      ? (await import('./NodeCookie')).NodeCookie.create({ config: this.config })
      : (await import('./WindowCookie')).WindowCookie.create({ config: this.config })
  }
}
